/**
 * Инициализирует корзины с опциями ответов
 * @param {Object} params - Параметры инициализации
 * @param {Array} params.baskets - Массив корзин
 * @param {boolean} params.hasAnswers - Есть ли ответы пользователя или правильные ответы
 * @param {Object} params.answers - Ответы пользователя (группированные по ID корзин) или правильные ответы
 * @param {Array} params.answerOptions - Все возможные варианты ответов
 * @returns {Array} Инициализированные корзины с опциями
 */
export const initializeBaskets = ({ 
  baskets, 
  hasAnswers = false,
  answers = {},
  answerOptions = []
}) => {
  return baskets.map(basket => {
    // Если нет ответов или нет данных по корзине, возвращаем пустые options
    if (!hasAnswers || !answers[basket.id]) {
      return { ...basket, options: [] };
    }

    const basketAnswers = answers[basket.id];
      // ложим в этот массив id ответов, которые 
      // относятся к этой корзине

    const options = answerOptions
      .filter(option => basketAnswers.some(
        answerId => answerId == option.id // Нестрогое сравнение
      ))
         // часть 2 фильтруем, чтобы остались только те варианты ответов, 
         // которые уже есть в basketAnswers
      .map(option => ({ 
        ...option, 
        parrentId: basket.id
      })); // options - массив вариантов ответов, который будет присвоен конкретной корзине

    return {
      ...basket,
      options
    };
  });
};